import queryString from 'query-string';
import areEqualShallow from '@/common/areEqualShallow';

export const hasQueryParam = function(locationOrSearch, queryParam) {
    const search = typeof locationOrSearch === 'string' ? locationOrSearch : locationOrSearch.search;
    const param = queryString.parse(search)[queryParam];
    return param !== undefined;
};

export const getQueryParam = function(locationOrSearch, queryParam) {
    const search = typeof locationOrSearch === 'string' ? locationOrSearch : locationOrSearch.search;
    return queryString.parse(search)[queryParam];
};

export const applyQueryParameter = function(location, params) {
    const current = queryString.parse(location.search, { arrayFormat: 'bracket' });
    const alreadyApplied = areEqualShallow(current, Object.assign({}, current, params));
    return [queryString.stringify(Object.assign(current, params), { arrayFormat: 'bracket' }), alreadyApplied];
};

export const resetQueryParameter = function(params) {
    return queryString.stringify(params);
};
